<div class="container-fluid p-4">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2>Organization Types</h2>
    <a class="btn btn-outline-secondary" routerLink="/organizations">Back to Organizations</a>
  </div>

  <div class="card mb-4">
    <div class="card-body">
      <form (ngSubmit)="create()">
        <div class="mb-3">
          <label for="name" class="form-label">Name</label>
          <input id="name" class="form-control" [(ngModel)]="newType.name" name="name" required />
        </div>

        <div class="mb-3">
          <label class="form-label">Intent Groups (optional)</label>
          <select class="form-select" multiple [(ngModel)]="newType.intentGroupsArr" name="intentGroups">
            <option *ngFor="let opt of intentGroupOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <div class="form-text">Select one or more intent groups (each only once).</div>
        </div>

        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
        <button class="btn btn-primary" type="submit" [disabled]="loading">Create</button>
      </form>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Existing Types</h5>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Intent Groups</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of organizationTypes">
            <td>{{ t.name }}</td>
            <td>{{ formatIntentGroups(t.intentGroups) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
